module.exports = __webpack_public_path__ + "logo-footer.jpg?13a23b73518eb98eb3ba7dba9fae0d02";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/layout/logo-footer.jpg
// module id = 113
// module chunks = 0